import AuthLayoutComponent from '../../features/ui/auth-layout/auth-layout';
import { ResetForm } from '@old/features/public/reset/reset-form';

export function ResetPage() {
  return (
    <AuthLayoutComponent>
      <ResetForm />
    </AuthLayoutComponent>
  );
}
